// src\pages\Service\ServicePage.tsx

export const ServicePage = () => {
    return (
        <div className="">
            ServicePage
        </div>
    )
}

export default ServicePage